import React, { useContext, useEffect, useState } from "react";
import { useFormikContext } from "formik";

import { AdminContext } from "../../context/AdminContext/AdminContext";
import { getRelatedServiceLines } from "../../services/servicesLine";

import SelectOption from "../SelectOption";

import styles from "./ChangeServiceLineForm.module.scss";

export const ChangeServiceLineForm = () => {
  const { userInfo } = useContext(AdminContext);
  const { values } = useFormikContext();

  const [relatedServiceLines, setRelatedServiceLines] = useState([]);
  const [nonRelatedServiceLines, setNonRelatedServiceLines] = useState([]);

  const getServiceLines = async (parent_id, line_service_id) => {
    try {
      const response = await getRelatedServiceLines(parent_id, line_service_id);
      const { data } = response || {};

      if (Array.isArray(data)) {
        const serviceLines = data.filter(
          (serviceLine) => serviceLine.id !== userInfo.service_line.id
        );

        if (!serviceLines.length) {
          setRelatedServiceLines([userInfo.service_line]);
          setNonRelatedServiceLines([]);
        } else {
          setRelatedServiceLines(serviceLines);
          setNonRelatedServiceLines([]);
        }

        return;
      }

      const {
        related_service_lines = [],
        non_related_service_lines = [],
      } = data || {};

      const filteredRelated = related_service_lines.filter(
        (serviceLine) => serviceLine.id !== userInfo.service_line.id
      );
      const filteredNonRelated = non_related_service_lines.filter(
        (serviceLine) => serviceLine.id !== userInfo.service_line.id
      );

      if (!filteredRelated.length && !filteredNonRelated.length) {
        setRelatedServiceLines([userInfo.service_line]);
        setNonRelatedServiceLines([]);
      } else {
        setRelatedServiceLines(filteredRelated);
        setNonRelatedServiceLines(filteredNonRelated);
      }
    } catch (error) {
      console.error(error);
      setRelatedServiceLines([userInfo.service_line]);
      setNonRelatedServiceLines([]);
    }
  };

  useEffect(() => {
    getServiceLines(
      userInfo.service_line.parent_id, 
      userInfo.service_line.id
    );
  }, []);

  const getSelectedNewServiceLineName = () => {
    if (!values || !values.service_line) return "";
    const parts = String(values.service_line).split("--");
    return parts[1] || "";
  };

  const newServiceLineName = getSelectedNewServiceLineName();

  return (
    <section className={styles.container}>
      <h2 className={styles.title}>Cambiar línea de servicio</h2>
      <SelectOption
        name="service_line"
        className={styles.selectInput}
      >
        <option value="" disabled>
          Selecciona la nueva línea de servicio asociada al evento
        </option>

        {relatedServiceLines.length > 0 && (
          <optgroup label="Líneas de servicio relacionadas">
            {relatedServiceLines.map(({ id, name, parent_id }) => (
              <option key={id} value={`${id}--${name}--${parent_id}`}>
                {name}
              </option>
            ))}
          </optgroup>
        )}

        {nonRelatedServiceLines.length > 0 && (
          <optgroup label="Otras líneas de servicio">
            {nonRelatedServiceLines.map(({ id, name, parent_id }) => (
              <option key={id} value={`${id}--${name}--${parent_id}`}>
                {name}
              </option>
            ))}
          </optgroup>
        )}
      </SelectOption>

      {values && values.service_line && newServiceLineName && (
        <p className={styles.disclaimer}>
          El evento cambiará de línea de servicio: {userInfo.service_line.name} -> {newServiceLineName}
        </p>
      )}
    </section>
  );
};